import type { LocaleNumberFormat } from './types'

const DEFAULT_FRACTION_DIGITS = 2

const groupIntegerDigits = (digits: string, group: string): string => {
  if (!group || digits.length <= 3) {
    return digits
  }

  const parts: string[] = []
  let index = digits.length

  while (index > 0) {
    const start = Math.max(0, index - 3)
    parts.unshift(digits.slice(start, index))
    index = start
  }

  return parts.join(group)
}

export const formatNumericBody = (value: unknown, format: LocaleNumberFormat): string => {
  const parsed = typeof value === 'number' ? value : Number.parseFloat(String(value))

  if (Number.isNaN(parsed)) {
    return String(value)
  }

  const fractionDigits = format.fractionDigits ?? DEFAULT_FRACTION_DIGITS
  const { group, decimal } = format
  const negative = parsed < 0 || Object.is(parsed, -0)
  const absolute = Math.abs(parsed)

  if (fractionDigits === 0) {
    const integerDigits = String(Math.trunc(absolute))
    const grouped = groupIntegerDigits(integerDigits, group)
    return negative ? `-${grouped}` : grouped
  }

  const fixed = absolute.toFixed(fractionDigits)
  const [integerPart = '0', fractionPart = ''] = fixed.split('.')
  const groupedInteger = groupIntegerDigits(integerPart, group)
  const body = `${groupedInteger}${decimal}${fractionPart}`

  return negative ? `-${body}` : body
}
